import { memo } from 'react';

import { Flex, Input, Label, TextField } from '@/components/core';
import { useTriggerStore } from '@/store';
import { toString } from '@/utils';

export type HttpUrlProps = {
  placeholder?: string;
  isDisabled?: boolean;
};

const IHttpUrl = ({ placeholder, isDisabled }: HttpUrlProps) => {
  const action = useTriggerStore((state) => state.action);
  const updateAction = useTriggerStore((state) => state.updateAction);

  return (
    <Flex col className="gap-md">
      <TextField
        onChange={(url) => updateAction({ config: { ...action.config, url } })}
        defaultValue={toString(action.config?.url)}
        isDisabled={isDisabled}
      >
        <Label isRequired>URL</Label>
        <Input placeholder={placeholder} />
      </TextField>
    </Flex>
  );
};

export const HttpUrl = memo(IHttpUrl) as typeof IHttpUrl;
